import { StreamPostType } from '@/__generated__/schema-types';

export type StreamExcludedPostTypesMap = Record<string, StreamPostType[]>;

// Twitter with Polymarket Enrichment
export const POST_TYPE_STREAM_IDS: ReadonlySet<string> = new Set([
  '01M3Y4VR9KQ1SGFTK6MBGA7YKS',
]);

export const POST_TYPE_OPTIONS: { type: StreamPostType; label: string }[] = [
  { type: StreamPostType.Retweet, label: 'Retweets' },
  { type: StreamPostType.Reply, label: 'Replies' },
  { type: StreamPostType.Quote, label: 'Quotes' },
];

type SourceConfigPostTypes = {
  stream: { id: string };
  excludedPostTypes: StreamPostType[];
};

export const sourceConfigsToExcludedPostTypesMap = (
  sourceConfigs?: SourceConfigPostTypes[] | null,
): StreamExcludedPostTypesMap =>
  Object.fromEntries(
    (sourceConfigs ?? [])
      .filter((config) => config.excludedPostTypes.length > 0)
      .map((config) => [config.stream.id, config.excludedPostTypes]),
  );
